import React, { useEffect, useState } from 'react';
import { Header } from '../../Header/Header';
import ReportMainComponent from './ReportMainComponent';
export const ReportEmployees: React.FC<any> = React.memo((props) => {
  const [reportData, setReportData] = useState<any[]>([]);
  return (
    <>
    <ReportMainComponent src='https://khsr.willsoar.in' headerTitle='Employee Report' id="empreport" title='Employee Report'/>
    </>
  
  );
}
)
